import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { useScreeningColumns } from "@/pages/screenings/hooks/use-columns";
import { IScreeningData } from "@/types/screening";

export const ScreeningsList = () => {
  const columns = useScreeningColumns();

  const table = useTable<IScreeningData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: { right: ["actions"] },
    },
    refineCoreProps: {
      meta: { defaultQueryBy: "movie.title" },
      sorters: { initial: [{ field: "startDate", order: "desc" }] },
      pagination: { pageSize: 25 },
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="screenings" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
